import { Component } from '@angular/core';

@Component({
  selector: 'app-analytics-pie-chart',
  templateUrl: './analytics-pie-chart.component.html',
  styleUrls: ['./analytics-pie-chart.component.scss']
})
export class AnalyticsPieChartComponent {
  data1 = [
    { value: 335, name: 'Used' },
    { value: 310, name: 'Unused' },
  ];
  // find the sum of all data values
  sum = this.data1.reduce((prev, current) => prev + current.value, 0);
  option: any = {
    title: {
      text: this.sum + "\n" + 'Total',
      left: 'center',
      top: '45%',
      textStyle: {
        // color: '#006699',
        fontSize: '15',
        display: 'block',
        innerWidth: '50%'
      },
    },
    toolbox: {
      // right:'20%',
      padding: [0, 0, 5, 0],
      itemSize: 13,
      iconStyle: {
        borderColor: "black",
        borderWidth: 1.1
      },
      feature: {
        // saveAsImage: {}
      }
    },
    tooltip: {
      trigger: 'item',
      formatter: '{a} <br/>{b}: {c} ({d}%)'
    },
    legend: {
      type: 'scroll',
      orient: 'vertical',
      right:'0%',
      // bottom:'95%',
      itemGap: 10,
      itemWidth: 13,
      itemHeight: 13,
      textStyle: {
        fontSize: '13',
        // padding:'2'
      },
    },

    series: [
      {
        name: 'Active License Count Of',
        type: 'pie',
        // left: '10%',
        top: 20,
        min: 100,
        max: 100,
        minSize: '0%',
        maxSize: '100%',
        radius: ['90%', '50%'],
        sort: 'descending',
        gap: 2,
        label: {
          show: true,
          position: 'inside',
          fontWeight: 'bold',
          fontSize: '13',
          formatter: function (d) {
            return d.value;
          }
        },
        labelLine: {
          length: 10,
          lineStyle: {
            width: 1,
            type: 'solid'
          }
        },
        itemStyle: {
          // borderColor: '#fff',
          // borderWidth: 1
        },
        emphasis: {
          label: {
            // fontSize: 20
          }
        },
        data: [
          { value: 335, name: 'Used' },
          { value: 310, name: 'Unused' },
        ]
      }
    ],
    color: [
      '#006699',
      '#16C599',
      '#E8DD11',
      '#F05457',
      '#74C1FF',
      '#2196F3'
    ]
  };

}
